module.exports = __webpack_public_path__ + "static/media/notification.4294d6d4.svg";